import React from 'react';
import Asset from 'src/requests/apa/Asset';
import Translator from 'src/requests/apa/Translator';
import Utils from 'src/utils/Utils';
import './_styles.scss';

const PlanSelectionCompleted = () => {
	const planSelectionCompletedIcon = Asset.get('Onboarding2_AlertaTodosLosPlanes_Icono_TodosLosPlanes');
	const planSelectionCompletedText = Utils.cutPlayerString(Translator.get('Onboarding2_AlertaTodosLosPlanes_Parrafo_Texto'), 70);

	return (
		<div className="plan-selection-completed">
			<div className="plan-selection-completed__content">
				<img 
					className="plan-selection-completed__icon" 
					src={planSelectionCompletedIcon} 
					alt="Icono de planes completos"
				/>
				<div className="plan-selection-completed__text-container">
					<p className="plan-selection-completed__text">{planSelectionCompletedText}</p>
				</div>
			</div>
		</div>
	);
};

export default PlanSelectionCompleted;



// WEBPACK FOOTER //
// ./src/payments/PlanSelector/PlanSelectionCompleted/index.jsx